<template>
  <div>
    <!-- Add option -->
    <b-form @submit.prevent="addOption" class="d-flex align-items-end">
      <b-form-group :label="$t('risk.template.option_name')" label-for="option-name" class="w-50 mb-0">
        <b-form-input
          id="option-name"
          v-model.trim="optionName"
          required
        />
      </b-form-group>

      <b-button type="submit" variant="primary" class="ml-1 mt-1">
        {{ $t('risk.template.add_option') }}
      </b-button>
    </b-form>

    <hr />

    <!-- List -->
    <div v-if="localOptions.length">
      <h5>{{ $t('risk.template.added_options') }}</h5>

      <b-table small :items="localOptions" :fields="fields" responsive>
        <!-- name (read-only) -->
        <template #cell(name)="{ item }">
          <span style="text-transform: none !important">{{ item.name }}</span>
        </template>

        <template #cell(actions)="{ index }">
          <b-button size="sm" variant="danger" @click="removeOption(index)">
            {{ $t('actions.delete') }}
          </b-button>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //father passes data that is the option array
    data: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      optionName: '',
      optionAllowComment: false,
      // Clon local, normilizes old options (if they have risk percentage we ignore it)
      localOptions: this.normalizeOptions(this.data),
      fields: [
        { key: 'name', label: this.$t('risk.template.name') },
        { key: 'actions', label: this.$tc('actions.name', 1) },
      ],
    };
  },
  computed: {
    tAllowComment () {
      return this.$t('custom_forms.allow_comment');
    }
  },
  methods: {
    normalizeOptions(arr) {
      const src = Array.isArray(arr) ? arr : [];
      return src.map(o => ({
        name: o?.name ?? '',
        //keeps compat if the flag already exits or its false by default
        allowComment: typeof o?.allowComment === 'boolean' ? o.allowComment : false,
      }));
    },
    emitUpdate() {
      //emits an object array
      this.$emit('update:data', [...this.localOptions]);
    },
    addOption() {
      if (!this.optionName) return;

      this.localOptions.push({
        name: this.optionName,
        allowComment: !!this.optionAllowComment,
      });

      // reset form
      this.optionName = '';
      this.optionAllowComment = false;

      this.emitUpdate();
    },
    removeOption(index) {
      this.localOptions.splice(index, 1);
      this.emitUpdate();
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.localOptions = this.normalizeOptions(newVal);
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables/_variables.scss";

h5 {
  transition: color 0.2s ease;

  .dark-layout & {
    color: $theme-dark-headings-color;
  }
}

hr {
  transition: border-color 0.2s ease;

  .dark-layout & {
    border-color: $theme-dark-border-color;
  }
}

// Ensure form elements have proper dark mode styling
::v-deep {
  .dark-layout {
    .form-group label {
      color: $theme-dark-label-color;
    }

    .form-control {
      background-color: $theme-dark-input-bg;
      border-color: $theme-dark-input-border-color;
      color: $theme-dark-body-color;

      &::placeholder {
        color: $theme-dark-input-placeholder-color;
      }

      &:focus {
        background-color: $theme-dark-card-bg;
        border-color: var(--primary);
        color: $theme-dark-headings-color;
      }
    }

    .table {
      background-color: $theme-dark-table-bg;
      color: $theme-dark-body-color;

      thead th {
        background-color: $theme-dark-table-header-bg;
        border-color: $theme-dark-border-color;
        color: $theme-dark-headings-color;
      }

      tbody td {
        border-color: $theme-dark-border-color;
      }

      tbody tr:hover {
        background-color: $theme-dark-table-hover-bg;
      }
    }

    .custom-switch {
      .custom-control-label::before {
        background-color: $theme-dark-switch-bg;
        border-color: $theme-dark-input-border-color;
      }

      .custom-control-input:checked ~ .custom-control-label::before {
        background-color: var(--primary);
        border-color: var(--primary);
      }
    }
  }
}
</style>
